import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, makeStyles,
  Typography,
} from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import PropTypes from 'prop-types';

import contactMentor from '../../assets/icons/ContactMentor.png';
import { setAnalytics } from '../../utils';

const useStyles = makeStyles((theme) => ({
  titleSection: {
    fontFamily: 'Raleway',
    fontWeight: 500,
    color: theme.palette.text.default,
  },
  cardResourcesNone: {
    background: theme.palette.background.card,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 4),
    margin: theme.spacing(2, 0),
    borderRadius: '10px',
  },
  cardResources: {
    background: theme.palette.background.card,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 4),
    margin: theme.spacing(2, 0),
    borderRadius: '10px',
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.grey,
      borderRadius: '10px',
      width: 15,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#1A3758',
      borderRadius: '10px',
    },
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.background.hoverCard,
    },
  },
  cardResourcesText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontWeight: 500,
    width: 140,
  },
  cardNoneResourcesText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontWeight: 500,
    margin: theme.spacing(3, 0),
  },
  cardMentor: {
    background: theme.palette.background.card,
    minHeight: 121,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    padding: theme.spacing(0, 6),
    borderRadius: '10px',
  },
  buttonCardMentor: {
    color: theme.palette.text.default,
    background: theme.palette.background.secondary,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.background.secondary,
    },
  },
  containerLinkResourse: {
    textDecoration: 'none',
    color: theme.palette.text.default,
    display: 'flex',
    flexDirection: 'row',
    textTransform: 'uppercase',
    margin: theme.spacing(1, 0),
  },
  containerLinkResourseText: {
    fontFamily: 'Raleway',
    width: '95%',
    margin: theme.spacing(0, 2),
    textTransform: 'capitalize',
  },
  iconResources: {
    width: '10%',
  },
}));
function UnitCard({ unit }) {
  const classes = useStyles();
  if (unit.type === 'pdf') {
    return (
      <a href={unit.link} className={classes.containerLinkResourse} target="_blank" rel="noreferrer">
        <PictureAsPdfIcon className={classes.iconResources} />
        <Typography className={classes.containerLinkResourseText}>
          {unit.title}
        </Typography>
      </a>
    );
  }
  if (unit.type === 'video') {
    return (
      <a href={unit.link} className={classes.containerLinkResourse} target="_blank" rel="noreferrer">
        <VideoLibraryIcon className={classes.iconResources} />
        <Typography className={classes.containerLinkResourseText}>
          {' '}
          {unit.title}
        </Typography>
      </a>
    );
  }
}
function Resources({ list }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const navigateChat = () => {
    setAnalytics('Lesson', 'Btn_AgendarMentor');
    navigate('/mentor');
  };
  return (
    <Box>
      <Typography className={classes.titleSection}> Recursos adicionales</Typography>
      <Box>
        <Card
          className={list !== undefined ? classes.cardResources : classes.cardResourcesNone}
          style={{
            maxHeight: 100,
            overflow: 'auto',
          }}
        >
          {list !== undefined
            ? list.map((e) => (
              <Box key={e.title}>
                <UnitCard unit={e} />
              </Box>
            ))
            : (
              <Typography
                className={classes.cardNoneResourcesText}
              >
                Lección no contiene recursos
              </Typography>
            )}
        </Card>
      </Box>
      <Box>
        <Card className={classes.cardMentor}>
          <img alt="contactMentor" src={contactMentor} />
          <Typography className={classes.cardResourcesText}>
            Comunicate con un mentor/asesor
          </Typography>
          <Button variant="contained" className={classes.buttonCardMentor} onClick={navigateChat}> Agendar </Button>
        </Card>
      </Box>
    </Box>
  );
}

export default Resources;

Resources.propTypes = {
  list: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
};
UnitCard.propTypes = {
  unit: PropTypes.objectOf(PropTypes.string).isRequired,
};
